import { z } from 'zod'
import { generatedAssetSchema } from './ai-studio-asset'

export const AI_TEXT_CREDIT_COST = 0
export const SOCIAL_IMAGE_CREDIT_COST = 400

export const aiTextKindSchema = z.enum([
  'facebook-post',
  'instagram-post',
  'event-description',
  'place-description',
])
export type AiTextKind = z.infer<typeof aiTextKindSchema>

export const generateTextRequestSchema = z.object({
  kind: aiTextKindSchema,
  prompt: z.string().min(1).max(1000),
})
export type GenerateTextRequest = z.infer<typeof generateTextRequestSchema>

export const generateTextResponseSchema = z.object({ text: z.string() })
export type GenerateTextResponse = z.infer<typeof generateTextResponseSchema>

/**
 * Which native frame the image model renders. Derived from where the image is
 * headed, not chosen by the user: `portrait` covers the crossposting targets
 * (9:16 story and 1:1 post), `landscape` covers the 16:9 event and place covers.
 */
export const socialImageOrientationSchema = z.enum(['portrait', 'landscape'])
export type SocialImageOrientation = z.infer<typeof socialImageOrientationSchema>

export const generateSocialImageRequestSchema = z.object({
  prompt: z.string().min(1).max(1000),
  orientation: socialImageOrientationSchema.default('portrait'),
  /** An event cover is held to the graphics-only rule: no people in the picture. */
  purpose: z.enum(['event-cover']).optional(),
})
export type GenerateSocialImageRequest = z.infer<typeof generateSocialImageRequestSchema>

export const generateSocialImageResponseSchema = z.object({ asset: generatedAssetSchema })
export type GenerateSocialImageResponse = z.infer<typeof generateSocialImageResponseSchema>
